<!-- components/PDFSelection.vue -->
<template>
    <div class="selection-container" :style="containerStyle" @mousedown.stop :class="{ temp: isTemp }">
      <div
        class="selection-rectangle"
        :style="rectangleStyle"
      ></div>
      <div v-if="!isTemp" class="selection-toolbar">
        <button class="selection-btn" @click="showDropdown = !showDropdown">
          <i class="mdi mdi-chevron-down"></i>
        </button>
        <button class="selection-btn" @click="onRemove">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <div class="selection-reason" :style="reasonStyle" v-if="showDropdown || (showDropdown && error.hasError)">
        <custom-select
          v-model="selectedOption"
          :options="selectOptions"
          placeholder="Select a reason"
          :open="true"
          :error="error"
          :onChange="handleSelectionChange"
          :isSearchable="true"
        />
        <custom-select
         v-model="selectedCode"
          v-if="Boolean(selectedOption)"
          :options="codeOptions"
          placeholder="Select document status"
          :open="true"
          :onChange="handleCodeChange"
          class="code-select"
        />
      </div>
    </div>
</template>
<script>
import CustomSelect from '../../commonComponents/customSelect.vue'
import { CODE_OPTIONS } from '../utils/constants'

export default {
  name: 'PDFSelection',
  components: {
    CustomSelect
  },
  props: {
    rect: Object,
    isTemp: Boolean,
    onRemove: Function,
    onChange: Function,
    handleCodeChange: Function,
    codeSelection: Boolean,
    reasonOptions: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      showDropdown: false,
      selectedOption: null,
      selectOptions: this.reasonOptions,
      showPopup: false,
      codeOptions: CODE_OPTIONS,
      showCodeSelection: this.codeSelection,
      selectedCode: null,
      error: {
        hasError: false,
        errorMessage: ''
      }
    }
  },
  methods: {
    handleSelectionChange (data) {
      this.selectedOption = data
      if (data) {
        this.rect.reason = data.label
        this.rect.piq_code = data.code
        if (this.rect.error) {
          this.rect.error.hasError = false
          this.rect.error.errorMessage = ''
        }
      } else {
        this.rect.reason = null
        this.rect.piq_code = null
        this.rect.error = {
          hasError: false,
          errorMessage: 'Reason is required'
        }
      }
      this.showCodeSelection = true
      this.onChange(this.rect)
    },
    onClickOutside (e) {
      if (!this.$el.contains(e.target)) {
        this.showCodeSelection = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.onClickOutside, true)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onClickOutside, true)
  },
  computed: {
    containerStyle () {
      return {
        position: 'absolute',
        top: `${this.rect.topPx}px`,
        left: `${this.rect.leftPx}px`
      }
    },
    rectangleStyle () {
      return {
        width: `${this.rect.widthPx}px`,
        height: `${this.rect.heightPx}px`
      }
    },
    reasonStyle () {
      return {
        left: `${this.rect.widthPx}px`
      }
    }
  },
  watch: {
    isTemp: {
      handler (newVal) {
        this.showDropdown = !newVal
      },
      immediate: true
    },
    rect: {
      immediate: true,
      handler () {
        if (this.rect.error) {
          this.showDropdown = true
          this.error = this.rect.error
        }
        if (this.rect.reason) {
          const selectedValue = this.selectOptions.find(item => item.label === this.rect.reason)
          if (selectedValue) {
            this.selectedOption = selectedValue
          }
        }
      }
    }
  }
}
</script>
  <style scoped>
  .selection-container {
    position: absolute;
  }
  .selection-rectangle {
    border: 2px solid rgba(var(--highlight-border));
    background-color: rgba(var(--highlight-border),0.2);
  }
  .selection-rectangle.temp {
    border-style: dashed;
  }
  .selection-toolbar {
    position: absolute;
    top: -0.6rem;
    right: -2px;
    display: flex;
    gap: 4px;
  }
  .selection-btn {
    width: 1.25rem;
    height: 1.25rem;
    display: grid;
    place-items: center;
    background: rgba(var(--highlight-border));
    font-size: 0.75rem;
    border-radius: 50%;
    cursor: pointer;
  }
  .selection-reason {
    width: 250px;
    height: fit-content;
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: .5rem;
    padding-left: 4px;
    top:0;
    z-index: 10;
  }
  .selection-reason .code-select {
    width: 100%
  }
  </style>
